export const EOL = {};
export const BREAK = {};
export const QUOTE = 34;
export const NEWLINE = 10;
export const RETURN = 13;

export const COLUMNS = 'columns';
export const NDJSON = 'ndjson';
export const ROWS = 'rows';
